<ui-confirmation-dialog
    header="surveys.store.surveyDetailsForm.templateRedirectHeader"
    primaryButtonLabel="surveys.store.surveyDetailsForm.templateRedirectContinue"
    primaryButtonType="danger"
    secondaryButtonLabel="surveys.store.surveyDetailsForm.templateRedirectCancel"
    #confirmNavigation
    [attr.data-cy]="'confirm_navigation'"
>
    <div class="margin-bottom-2">
        <p>{{ 'surveys.store.surveyDetailsForm.templateRedirectMsg' | translate }}</p>
    </div>
</ui-confirmation-dialog>

<form style="max-width: 800px" #form="ngForm">
    <ng-container *ngIf="survey">
        <div class="app-grid">
            <app-segment-header title="surveys.store.surveyDetailsForm.surveyDetailsTitle"></app-segment-header>
            <mat-form-field class="columns-12">
                <mat-label>{{ 'surveys.store.surveyDetailsForm.titleLabel' | translate }}</mat-label>
                <input matInput type="text" name="title" required #title="ngModel" [(ngModel)]="survey.title" />
                <mat-error *ngIf="title.invalid">{{ title.errors | formErrors }}</mat-error>
            </mat-form-field>
            <mat-form-field class="columns-12">
                <mat-label>{{ 'surveys.store.surveyDetailsForm.descriptionLabel' | translate }}</mat-label>
                <textarea name="description" rows="2" [(ngModel)]="survey.description" matInput></textarea>
            </mat-form-field>

            <mat-form-field class="columns-12">
                <mat-label>{{ 'surveys.store.surveyDetailsForm.templateLabel' | translate }}</mat-label>

                <ui-survey-template-autocomplete
                    name="templateId"
                    required
                    #template="ngModel"
                    [(ngModel)]="selectedTemplate"
                    (ngModelChange)="templateChanged($event)"
                    (templatesLoaded)="templatesLoaded.emit($event)"
                >
                </ui-survey-template-autocomplete>
                <mat-error *ngIf="template.invalid">{{ template.errors | formErrors }}</mat-error>
                <mat-hint *ngIf="canViewHelperText" class="template-helper-text"
                    >{{ 'surveys.store.surveyDetailsForm.createNewTemplateMsg' | translate }}
                    <a
                        (click)="goToTemplatesClicked()"
                        [innerHtml]="'surveys.store.surveyDetailsForm.goToTemplatesLinkMsg' | translate"
                    ></a
                ></mat-hint>
            </mat-form-field>

            <app-segment-header
                title="surveys.store.surveyDetailsForm.scheduleTitle"
                class="margin-top-3"
            ></app-segment-header>
            <mat-form-field class="columns-12">
                <mat-label>{{ 'surveys.store.surveyDetailsForm.dueDateLabel' | translate }}</mat-label>
                <input
                    name="due_at"
                    required
                    #dueAt="ngModel"
                    [ngModel]="survey.dueAt | appDate: 'yyyy-MM-dd'"
                    (ngModelChange)="survey.dueAt = $event"
                    placeholder="{{ 'surveys.store.surveyDetailsForm.selectDueDatePlaceholder' | translate }}"
                    [matDatepicker]="dueAtPicker"
                    matInput
                />
                <mat-datepicker-toggle matSuffix [for]="dueAtPicker">
                    <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #dueAtPicker></mat-datepicker>
                <mat-error *ngIf="dueAt.invalid">{{ dueAt.errors | formErrors }}</mat-error>
            </mat-form-field>

            <ng-container *ngIf="!survey.isPersisted">
                <app-segment-header title="surveys.store.surveyDetailsForm.anonymousTitle"></app-segment-header>
                <div class="columns-12">
                    <mat-label id="is_anonymous_label" class="margin-bottom-2">{{
                        'surveys.store.surveyDetailsForm.anonymousLabel' | translate
                    }}</mat-label>

                    <mat-radio-group
                        class="vertical"
                        name="is_anonymous"
                        [(ngModel)]="survey.isAnonymous"
                        aria-labelledby="is_anonymous_label"
                    >
                        <mat-radio-button [value]="true" class="margin-bottom-2">{{
                            'yes' | translate
                        }}</mat-radio-button>
                        <mat-radio-button [value]="false" class="margin-bottom-2">{{
                            'no' | translate
                        }}</mat-radio-button>
                    </mat-radio-group>
                </div>
            </ng-container>
        </div>
    </ng-container>
</form>
